/**
 * TreeRowMenu — 강의 나무 줄의 더보기(⋯) 판.
 *
 * 항목의 얼굴은 시험지 폴더 메뉴(ExamPapersV2/FolderTree.jsx FolderMenu)를 따른다 — 머리(이름 · 성격 한 줄) 아래
 * 아이콘 + 글자 한 줄 항목, 지우기는 맨 아래 빨간 글자. 같은 「나무 줄 메뉴」가 두 화면에서 다른 얼굴이면 같은 조작인 줄 모른다.
 * 폴더 메뉴를 통째로 쓰지 않는 이유: 공유·옮길 폴더 목록 같은 폴더 전용 겹이 섞여 있다. 떠 있는 판은 공용 FloatingPanel 이 맡는다.
 *
 * 무엇을 할 수 있는지는 나무가 정해 넘긴다(actions). 여기는 그리기만 한다 — 판정이 두 곳에 있으면 한쪽만 고쳐지는 날
 * 막힌 항목이 눌리게 된다. 막힌 항목은 지우지 않고 잠근 채 이유를 title 에 적는다(왜 없는지 묻지 않게).
 */
import FloatingPanel from './FloatingPanel';
import MathName from './MathName';

const rowCls = 'flex w-full items-center gap-2 rounded-lg px-2 py-1.5 text-left text-xs transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-40';

/**
 * props
 *   anchorRef — 연 [⋯] 버튼(자리·초점 복귀)
 *   name      — 줄 이름(머리)
 *   caption   — 머리 둘째 줄(「조건 행」 · 「제목 행 · 하위 3개」)
 *   actions   — [{ key, label, Icon, onSelect, disabled, reason, danger, separated }]
 *   onClose(reason)
 */
function TreeRowMenu({
  anchorRef, name, caption = '', actions = [], onClose,
}) {
  return (
    <FloatingPanel anchorRef={anchorRef} onClose={onClose} align="end" label={`${name} 행 메뉴`} className="w-56">
      <p className="truncate px-2 pt-0.5 text-xs font-bold text-gray-800" title={name}><MathName text={name} compact /></p>
      {caption && <p className="px-2 pb-1 text-[10px] font-medium text-gray-400">{caption}</p>}
      {actions.map(({
        key, label, Icon, onSelect, disabled, reason, danger, separated,
      }) => (
        <div key={key} className={separated ? 'mt-1 border-t border-gray-100 pt-1' : ''}>
          <button
            type="button"
            data-menu-action={key}
            onClick={onSelect}
            disabled={disabled}
            title={disabled && reason ? reason : undefined}
            className={`${rowCls} ${danger ? 'text-red-700 hover:bg-red-50' : 'text-gray-700 hover:bg-gray-50'}`}
          >
            {Icon && <Icon aria-hidden="true" className={`size-3.5 shrink-0 ${danger ? 'text-red-400' : 'text-gray-400'}`} />}
            <span className="min-w-0 flex-1 truncate">{label}</span>
          </button>
        </div>
      ))}
    </FloatingPanel>
  );
}

export default TreeRowMenu;
